import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
  Text,
  Textarea,
  VStack,
  Avatar,
  Badge,
  Flex,
  Box,
  useToast,
  Checkbox,
} from "@chakra-ui/react";
import axios from "axios";
import { ACCOUNTS_URL, BASE_URL } from "../../../../../Globalapi/Globalapi";

const Modal_Pay_student = ({
  memberId,
  totalAmount,
  fineeId,
  isOpen,
  onClose,
  feeName,
  feeMasterId,
  onPay,
  defaultAmount = "",
  last,
  amount,
  status,
  studentledid,
  feeId,
  start,
  staffId,
  userId,
  StudentLedgerId,
  memberType,
  Return
}) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    feesGroup: "",
    feesType: feeName,
    amount: defaultAmount,
    collectionDate: "2025-01-03",
    paymentReference: "",
    status: false,
    notes: "",
    selectedFees: [],
  });

  const [studentData, setStudentData] = useState(null);
  const [error, setError] = useState(null);
  const [ledgerId, setLedgerId] = useState(null); // State for storing the ledgerId
  const [unassignedFees, setUnassignedFees] = useState([]);
  const [assignedFees, setassignedFees] = useState([]);
  const [amt, setAmt] = useState();
  const [BusLedgerId, setBusLedgerId] = useState(null);
  console.log("user id", userId);

  // Fetch student or teacher data based on memberType
  useEffect(() => {
    const fetchProfileData = async () => {
      const apiUrl =
        memberType === "Student"
          ? `${BASE_URL}/student/student_profile.php`
          : `${BASE_URL}/staff/profile/staff_profile.php`;

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ pass: userId }),
        });
        const data = await response.json();

        if (data.success) {
          setStudentData(data.data);
        } else {
          setError("Failed to fetch data.");
          toast({
            title: "Error",
            description: "Failed to fetch data.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (err) {
        setError("An error occurred while fetching data.");
        toast({
          title: "Error",
          description: "An error occurred while fetching data.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetchProfileData();
  }, [memberType, userId, toast]);

  // Fetch Payment Methods and Ledger IDs (Cash or Online)
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      const schoolId = sessionStorage.getItem("school_id");

      try {
        let cashLedgerId, bankLedgerId;

        if (formData.paymentType === "1") {
          // No need to call any additional API for Cash
          const response = await axios.post(
            `${ACCOUNTS_URL}/common/get_default_cash.php`,
            {
              cmp_id: schoolId, // Pass the user_id here
            }
          );
          console.log("====================================");
          console.log(response);
          console.log("====================================");
          const cashLedger = response.data.data[0];

          cashLedgerId = cashLedger.ledg_id; // You can hardcode or retrieve it elsewhere if needed
          setLedgerId(cashLedgerId);
        } else if (formData.paymentType === "2") {
          // Fetch bank ledger ID with POST request
          const responseBank = await axios.post(
            `${ACCOUNTS_URL}/common/get_default_bank.php`,
            {
              cmp_id: schoolId, // Pass the user_id here
            }
          );
          console.log("====================================");
          console.log(responseBank);
          console.log("====================================");
          const bankLedger = responseBank.data.data[0];
          bankLedgerId = bankLedger.ledg_id; // Extract the ledger_id
          setLedgerId(bankLedgerId);
          if (responseBank.data.status === "success") {
            const bankLedger = responseBank.data.data[0];
            bankLedgerId = bankLedger.ledg_id; // Extract the ledger_id
            setLedgerId(bankLedgerId);
          } else {
            toast({
              title: "Error",
              description: "Failed to fetch bank ledger ID.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        }
      } catch (err) {
        toast({
          title: "Error",
          description: "An error occurred while fetching payment methods.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    // Fetch payment method related data and ledger ID
    fetchPaymentMethods();
  }, [formData.paymentType, toast]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Inside your JSX, calculate the total dynamically when the checkbox is toggled

  const handlePay = async () => {
    setLoading(true);
    // const userId = sessionStorage.getItem("user_id");
    const cmpId = sessionStorage.getItem("cmp_id");
    const schoolId = sessionStorage.getItem("school_id"); // Assuming school_id is also stored
    const fineId = formData.fineId; // Assuming fineId is stored in formData
    const fineAmount = formData.fineAmount; // Assuming fineAmount is stored in formData
    const transactionReference = formData.transactionReference; // Assuming this is from formData or somewhere else

    try {
      let apiUrl =
        `${BASE_URL}/admin/library/issues/pay_fine.php`; // Correct API URL
      const paymentMode =
        formData.paymentType === "1"
          ? "Cash"
          : formData.paymentType === "2"
          ? "Bank"
          : "null"; // Default to "null" if not valid

      // Check if payment mode is 'Bank', then ensure transaction reference is provided
      // if (paymentMode === "Bank" && !transactionReference) {
      //   toast({
      //     title: "Error",
      //     description: "Transaction reference is required for bank payments.",
      //     status: "error",
      //     duration: 3000,
      //     isClosable: true,
      //   });
      //   setLoading(false);
      //   return;
      // }

      const payload = {
        member_id: memberId,
        user_id: userId,
        school_id: schoolId,
        fine_id: fineeId,
        fine_amount: totalAmount,
        payment_mode: paymentMode,
        transaction_reference:"ghg", // Only include for Bank payments
        payment_ledger_id: ledgerId, // Adjust based on your system
        member_ledger_id: StudentLedgerId, // Assuming this is passed in
      };

      console.log("API URL:", apiUrl);
      console.log("Payload:", payload);

      const response = await axios.post(apiUrl, payload);
      console.log("Response:", response);

      if (response.data.success) {
        toast({
          title: "Payment Successful",
          description: `Paid the fine successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        if (onPay) {
          onPay(totalAmount); // Trigger any callback you may have after payment is successful
        }
        Return();
        onClose(); // Close modal or any UI element
      } else {
        toast({
          title: "Payment Failed",
          description: response.data.message || "An error occurred.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast({
        title: "Error",
        description: "An error occurred. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex justify="space-between" align="center">
            <Flex align="center" gap={2}>
              <Text fontSize="xl">Collect Fees</Text>
              <Badge colorScheme="blue" fontSize="md" px={2} py={1}>
                AD124556
              </Badge>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {/* Student Info Card */}
          {studentData && (
            <Box bg="gray.50" p={6} borderRadius="lg" mb={6}>
              <Flex gap={4}>
                <Avatar
                  size="md"
                  name={studentData.name}
                  src={studentData.imgUrl}
                />
                <Box flex="1">
                  <Flex
                    align="center"
                    justifyContent="space-between"
                    gap={2}
                    mb={2}
                  >
                    <Text fontWeight="semibold">{studentData.name}</Text>
                    <Text color="gray.600">
                      {[studentData.class_name, studentData.section]
                        .filter(Boolean) // Removes any falsy values like null or empty strings
                        .join(" ")}{" "}
                      {/* Joins with a space, no comma */}
                      {studentData.class_teacher_for &&
                        `  ${studentData.class_teacher_for}`}
                    </Text>

                    {/* Display the class here */}
                    <Box>
                      <Text color="gray.600" fontSize="sm">
                        Total Outstanding
                      </Text>
                      <Text fontWeight="semibold">₹{totalAmount}</Text>{" "}
                    </Box>
                    <Box>
                      <Text color="gray.600" fontSize="sm">
                        Last Date
                      </Text>
                      <Text fontWeight="semibold">{last}</Text>
                    </Box>
                    <Badge
                      colorScheme={status === "paid" ? "green" : "red"}
                      borderRadius="full"
                      variant="subtle"
                    >
                      {status}
                    </Badge>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          )}

          {/* Payment Method Form */}
          <VStack spacing={6}>
            <Flex gap={6} w="full">
              <FormControl>
                <FormLabel>Payment Type</FormLabel>
                <Select
                  value={formData.paymentType}
                  onChange={(e) =>
                    handleInputChange("paymentType", e.target.value)
                  }
                >
                  <option value="">Select</option>
                  <option value="1">Cash</option>
                  <option value="2">Online</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Payment Reference No</FormLabel>
                <Input
                  placeholder="Enter Payment Reference No"
                  value={formData.paymentReference}
                  onChange={(e) =>
                    handleInputChange("paymentReference", e.target.value)
                  }
                />
              </FormControl>
            </Flex>

            <FormControl>
              <Flex align="center" justify="space-between">
                <FormLabel mb={0}>Status</FormLabel>
                <Switch
                  size="md"
                  isChecked={formData.status}
                  onChange={(e) =>
                    handleInputChange("status", e.target.checked)
                  }
                />
              </Flex>
              <Text fontSize="sm" color="gray.600" mt={1}>
                Change the Status by toggle
              </Text>
            </FormControl>

            <FormControl>
              <FormLabel>Notes</FormLabel>
              <Textarea
                placeholder="Add Notes"
                value={formData.notes}
                onChange={(e) => handleInputChange("notes", e.target.value)}
                resize="vertical"
              />
            </FormControl>

            <Flex gap={4} w="full" justify="flex-end">
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="blue"
                onClick={handlePay}
                isLoading={loading}
                loadingText="Processing"
              >
                Pay Fees
              </Button>
            </Flex>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default Modal_Pay_student;
